import RfiDetailsDrawer from './RfiDetailsDrawer.component';

export default RfiDetailsDrawer;
